export default "__VITE_ASSET__428ab9e3__"